import { ListItem } from '@tableau/widgets';

import { ISiteAdminProfile } from '../users/serverApi/requests/GetSiteAdminProfilesRequest';
import { getAdminProfileListItems } from './AdminProfileDropdownHelper';

export const SITE_MEMBERSHIP_GRID_DROPDOWN_WIDTH = 200;

/**
 * Left inset of the admin-profile `SingleSelectDropdown` in `SiteMembershipGridColumns`: the wrapper uses this as
 * `marginLeft`. Control width is {@link SITE_MEMBERSHIP_GRID_DROPDOWN_WIDTH} minus this inset and
 * {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_OVERLAY_RIGHT_TRIM}. Do not change only `marginLeft` without updating
 * {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_CONTROL_WIDTH}.
 *
 * The popup wrapper's `minWidth` follows the button's `getBoundingClientRect()`. The inner `List` uses
 * {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_POPUP_LIST_WIDTH} so the wrapper's outer edge matches the button; see
 * {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_WIDGETS_POPUP_HORIZONTAL_BORDER}.
 */
export const SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_LEFT_INSET = 10;

/**
 * Subtract from the control width so the open menu (including scrollbar) lines up with the visible outline button.
 * `getBoundingClientRect()` on the anchor can be slightly wider than perceived chrome; margin {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_LEFT_INSET}
 * is unchanged so the control does not shift horizontally in the cell.
 */
export const SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_OVERLAY_RIGHT_TRIM = 2;

/**
 * The open menu is wrapped by `@tableau/widgets` FocusTrap using `Standard.PopupStyle` (`borderWidth: 1`, `boxSizing:
 * 'border-box'`). `minWidth` on that wrapper matches the button's border-box width ({@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_CONTROL_WIDTH}).
 * If the inner `List` uses the same width as the button, the wrapper needs an extra 1px border on each side and its
 * outer edge grows past the button — the "stuck" overhang that does not respond to {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_OVERLAY_RIGHT_TRIM}.
 */
export const SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_WIDGETS_POPUP_HORIZONTAL_BORDER = 2;

/** Width of the outline dropdown button (border box) inside the grid admin-profile cell. */
export const SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_CONTROL_WIDTH =
  SITE_MEMBERSHIP_GRID_DROPDOWN_WIDTH -
  SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_LEFT_INSET -
  SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_OVERLAY_RIGHT_TRIM;

/**
 * Width of the `List` inside the popup so the FocusTrap's outer border box matches {@link SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_CONTROL_WIDTH}.
 */
export const SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_POPUP_LIST_WIDTH =
  SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_CONTROL_WIDTH -
  SITE_MEMBERSHIP_GRID_ADMIN_PROFILE_WIDGETS_POPUP_HORIZONTAL_BORDER;

/** List items for the grid admin profile dropdown; tooltip on hover shows full name when text is long. */
export function getAdminProfileListItemsForSiteMembershipGrid(
  profiles: ISiteAdminProfile[],
  noneValue: string,
): ListItem[] {
  return getAdminProfileListItems(profiles, noneValue).map((item) => ({
    ...item,
    tooltip:
      typeof item.content === 'string' ? item.content : (item.value ?? ''),
  }));
}
